import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDebounce } from "use-lodash-debounce";
import useSelfpointEffect from "../common3/hooks/useSelfpointEffect";
import { Link } from "react-router-dom";
import { Wrapper, Table, THead, TBody, TR, TH, TD, Icon, Text } from "./styled";
import moment from "moment";
import get from "lodash/get";
import produce from "immer";
import FormLabel from "../FormLabel";
import { injectIntl } from 'react-intl'
import DotLoader from '../common3/Loaders/DotLoader'
import MoreDropDown from './MoreDropDown'
import Checkbox from './Checkbox/index'
import styled from "styled-components";
import filterComponents from './filterComponents'

import cols from "./columns";

import PaginationBar from "./PaginationBar";

const ColGroup = ({ columns }) => {
  const getColumntWidth = (width) => {
    switch (width) {
      case "xs":
        return "5% !important";
      case "s":
        return "10%";
      case "m":
        return "15%";
      case "l":
        return "25%";
      case "xl":
        return "50%";
      default:
        return null;
    }
  };

  return (
    <colgroup>
      {columns.map((c, i) => {
        return (
          <col key={i} span="1" style={{ width: getColumntWidth(c.width) }} />
        );
      })}
    </colgroup>
  );
};

const StyledIcon = styled.div`
  color: ${(p) => (p.selected ? p.theme.colors.info : "lightgrey")};
  margin-left: 5px;
  cursor: pointer;

  transition: all 150ms ease;
  &:hover {
    color: ${(p) => p.theme.colors.info};
  }
`;

const Search = styled.input`
  background-color: transparent;
  border: none;
  border-bottom: 1px solid black;
  // margin-bottom: 10px;
  outline: none;

  &:focus {
    border: none;
    border-bottom: 1px solid ${(p) => p.theme.colors.info};
    outline: none;
  }
  &:active {
    border-bottom: 1px solid ${(p) => p.theme.colors.info};
  }
`;

const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 75px;
  padding-bottom: 75px;
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 1.2rem;
  border: 1px solid ${(p) => p.theme.colors.border};
  border-radius: 4px;
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const FilterBadge = styled.div`
  background-color: #ccc;
  border-radius: 5px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  padding-right: 10px;
  font-size: 0.7rem;
  height: 27px;
  margin-left: 10px;
`;

const FilterIcon = styled.div`
  margin-right: 3px;
  cursor: pointer;

  &:hover {
    color: ${(p) => p.theme.colors.danger};
  }
`;

const TopBar = styled.div`
  margin-bottom: 10px;
  padding-bottom: 20px;
  display:flex;
  align-items: flex-end;
  // border-bottom: 1px solid #bbb;
`

const PageSizeWrapper = styled.ul`
  margin:0px;
  margin-left: ${p => p.selected.length > 0 ? '20px' : 'auto'};
  display:flex;
  padding: 0px;
  align-items:center;
  list-style-type: none;
`

const Page = styled.li`
  font-size: 0.9rem;
  font-weight: ${p => p.selected ? 'bold' : 'normal'};
  border-right: 1px solid ${p => p.theme.colors.border};
  padding: 0px 10px;
  cursor: pointer;
  text-decoration: none;

  &:last-child {
    border-right: none;
  } 

  &:hover {
    border-bottom: 1px solid ${p => p.theme.colors.secondary};
  }
  
`

const Reload = styled.div`
  font-size: 0.9rem;
  &:hover {
    border-bottom: 1px solid ${p => p.theme.colors.secondary};
  }
  cursor:pointer;
  margin-right:10px;
`

const MoreWrapper = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
`


const FilterButton = ({ index, filter, removeFilter }) => {
  if (typeof filter !== 'string') {
    return null
  }

  return (
    <FilterBadge>
      <FilterIcon
        data-index={index}
        onClick={removeFilter}
        className="fal fa-times-circle"
      />
      {filter}
    </FilterBadge>
  );
};

const SortIcon = ({ name, sort = {} }) => {

  const icon =
    sort[name] === 1 ? "fa fa-sort-alpha-up" : "fa fa-sort-alpha-down";

  return <StyledIcon /* className="sp-tickets-sort-icon" */ data-name={name} selected={sort[name]} className={icon} />;
};

const Tickets = (props) => {
  const {
    extra = {},
    setUserPersistentProfile,
    id,
    userPersistentProfile,
    save,
    document,
    intl,
    dirty = {},
    runEffect,
    effectsLoading,
    permissions = []
  } = props;
  const {
    effects: _effect = {},
    hasPagination = false,
    hasFilter = false,
    label = null,
    noDataHeading,
    noDataText,
    pageSize: configPageSize = 10,
    enablePageSize = false,
    multiSelect = false,
    dropDownLabel = undefined,
    actionButtons = [],
  } = extra;



  const thisConfig = get(userPersistentProfile, [id], {});

  const {
    pageSize: _pageSize = +configPageSize,
    page: _page = 1,
    filter: _filter = "",
    filters: _filters = [],
    sort: _sort = {},
  } = thisConfig;

  const effectConfig = get(extra, "effects", []);


  const [pageSize, setPageSize] = useState(_pageSize);
  const [page, setPage] = useState(_page);
  const [_reload, setReload] = useState(null);
  const [filter, setFilter] = useState(_filter);
  const [filters, setFilters] = useState([]);
  const [allSelected, setAllSelected] = useState(false)
  const [selected, setSelected] = useState([])
  const [showModal, setShowModal] = useState(false)

  const columns = get(effectConfig, "[0].columns", []);
  const defaultSort = "created"; //get(columns, "[0].value", null);

  const [sort, setSort] = useState({});

  const formDataDirty = dirty['formData']

  const [loading, effect] = useSelfpointEffect({
    ...props,
    context: {
      page: page,
      pageSize: pageSize,
      sort: sort,
      filter: filter,
      filters: filters,
    },
    watchArray: [page, sort, pageSize, filter, filters, formDataDirty, _reload, document],
  });

  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      setUserPersistentProfile({
        [id]: {
          page,
          sort,
          pageSize,
          filter,
          filters,
        }
      });
    } else {
      didMountRef.current = true;
    }
  }, [page, sort, pageSize, filter, filters]);

  const didMountRef2 = useRef(false);

  useEffect(() => {
    if (didMountRef2.current) {
      if (!effectsLoading["deleteTicket"]) {
        setReload(new Date())
      }
    } else {
      didMountRef2.current = true;
    }
  }, [effectsLoading["deleteTicket"]])

  useEffect(() => {
    setPage(1)
  }, [filter])

  const onSortClick = useCallback((e) => {
    const name = get(e, "currentTarget.dataset.name", null);

    setSort(
      produce((draft) => {
        if (draft[name]) {
          return {
            [name]: draft[name] * -1,
          };
        } else {
          return {
            [name]: -1,
          };
        }
      })
    );
  });

  const runActionButton = effects => {
    if (!selected.length || !effects || !effects.length) {
      return
    }

    runEffect({ source: 'ActionButton/run', effectId: "runActionButton", context: { selected, effectsToRun: effects, sort } })
  }

  const removeSelected = useCallback(() => {
    if (selected.length) {
      runEffect({ source: 'Ticket/delete', effectId: "deleteTicket", context: { selected } })
      setSelected([])
    }
  }, [selected])

  const checkForEnter = useCallback(
    (e) => {
      if (e.key === "Enter") {
        setFilters(
          produce((draft) => {
            draft.push(filter);
          })
        );
        setFilter("");
      }
    },
    [filter]
  );

  const removeFilter = useCallback(
    (e) => {
      const index = get(e, "currentTarget.dataset.index");

      setFilters(
        produce((draft) => {
          draft.splice(index, 1);
        })
      );
    },
    [filters]
  );


  const extractLabelKey = label => {

    if (label) {
      const _array = label.split('.')
      const _label = _array[0]
      const _field = _array[1]
      return [_label, _field]
    } else {
      return [null, null]
    }
  }

  const reload = useCallback(e => {
    setReload(new Date())
  })

  if (!effect) {

    return <DotLoader />
  }

  const { data, totalCount } = effect;

  if (!columns) {
    return "no columns";
  }

  if (!Array.isArray(data)) {
    return <div>Corrupt</div>;
  }

  moment.locale("sv");

  const onSelectAll = () => {
    const ids = data.map(({ _id = '' }) => _id)

    if (ids.some(id => !selected.includes(id))) {
      setSelected(ids)
      setAllSelected(true)

      return
    }

    setSelected([])
    setAllSelected(false)
  }

  const onSelect = rowId => {
    if (selected.includes(rowId)) {
      setSelected(selected.filter(id => id !== rowId))
      setAllSelected(false)

      return
    }

    setSelected([...selected, rowId])

    const ids = data.map(({ _id = '' }) => _id)

    if (ids.every(id => [...selected, rowId].includes(id))) {
      setAllSelected(true)
    }
  }

  return (
    <React.Fragment>
      <FormLabel label={label} />
      <Wrapper>
        <TopBar>
          {hasFilter && (
            <FilterWrapper>
              <Search
                className='sp-tickets-filter'
                placeholder="Filtrera"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                onKeyDown={checkForEnter}
              />
              {filters.map((filter, i) => {
                return (
                  <FilterButton
                    key={`filter-${i}`}
                    filter={filter}
                    index={i}
                    removeFilter={removeFilter}
                  />
                );
              })}
              <div>
                {
                  columns.map(col => {
                    if (!col.filter) {
                      return null
                    }

                    const path = col.key ? col.value + '.' + col.key : col.value

                    const FilterComponent = filterComponents[col.type]

                    return <FilterComponent label={col.label} path={path} setFilters={setFilters} />
                  })
                }
              </div>
            </FilterWrapper>
          )}
          {selected.length > 0 && (
            <MoreWrapper>
              <MoreDropDown permissions={permissions} numOfSelected={selected.length} runActionButton={runActionButton} removeSelected={removeSelected} dropDownLabel={dropDownLabel} actionButtons={actionButtons} intl={intl} />
            </MoreWrapper>
          )}
          {
            enablePageSize && (
              <PageSizeWrapper selected={selected}>
                <Reload onClick={reload}>{intl.formatMessage({ id: 'Reload' })}</Reload>
                {
                  [5, 10, 15, 25, 50, 100].map(size => {
                    return <Page key={size} onClick={() => { setPageSize(size); setPage(1) }} selected={size === pageSize}>{size}</Page>
                  })
                }
              </PageSizeWrapper>
            )
          }
        </TopBar>
        <Table className="sp-tickets-table">
          <ColGroup columns={columns} />
          <THead className="sp-tickets-thead">
            <TR className="sp-tickets-thead-tr">
              {
                multiSelect && (
                  <TH>
                    <Checkbox checked={allSelected} onSelectAll={onSelectAll} onClick={onSelectAll} value={false} />
                  </TH>
                )
              }
              {columns.map((col, i) => {

                const [_label, _field] = extractLabelKey(col.label)


                if (col.display === true) {
                  if (col.type === 'arrayObject') {
                    const numOfItems = data.reduce((acc, row) => {
                      //Extra check to make sure we have a value (Not undefined)
                      if (row[col.value] && (row[col.value].length > acc)) {
                        return row[col.value].length
                      }

                      return acc
                    }, 0)

                    if (numOfItems > 1) {
                      return Array(numOfItems).fill('').map((c, colIdx) => (
                        <TH
                          className="sp-tickets-th"
                          sortable={col.sortable}
                          data-name={col.value + '.' + col.key}
                          key={"th" + i + '-' + colIdx}
                          onClick={col.sortable ? onSortClick : () => { }}
                        >
                          {col.type !== 'notifications' && _label + ' (' + (colIdx + 1) + ')'}{" "}
                          {col.sortable && (
                            <SortIcon name={col.value} sort={sort} />
                          )}
                        </TH>
                      ))
                    }
                    else {
                      return (
                        <TH
                          className="sp-tickets-th"
                          sortable={col.sortable}
                          data-name={col.value + '.' + col.key}
                          key={"th" + i}
                          onClick={col.sortable ? onSortClick : () => { }}
                        >
                          {col.type !== 'notifications' && _label}{" "}
                          {col.sortable && (
                            <SortIcon name={col.value} sort={sort} />
                          )}
                        </TH>
                      )
                    }
                  }
                  return (
                    <TH
                      className="sp-tickets-th"
                      sortable={col.sortable}
                      data-name={col.key ? col.value + '.' + col.key : col.value}
                      key={"th" + i}
                      onClick={col.sortable ? onSortClick : () => { }}
                    >
                      {col.type !== 'notifications' && _label}{" "}
                      {col.sortable && (
                        <SortIcon name={col.value} sort={sort} />
                      )}
                    </TH>
                  );
                } else {
                  return null;
                }
              })}
            </TR>
          </THead>
          <TBody className="sp-tickets-tbody">
            {data.map((row) => {
              return (
                <TR key={`${row._id}-tr`} className="sp-tickets-tr">
                  {
                    multiSelect && (
                      <TD>
                        <Checkbox checked={selected.includes(row._id)} onSelect={onSelect} rowId={row._id} onClick={e => onSelect(row._id)} />
                      </TD>
                    )
                  }
                  {columns.map((col, i) => {

                    const [_label, _field] = extractLabelKey(col.label)

                    if (col.display) {
                      const Comp =
                        cols[
                        col.value === "details"
                          ? "link"
                          : col.type === 'object' || col.type === 'arrayObject' ? 'string'
                            : col.type
                              ? col.type
                              : "string"
                        ];

                      if (col.type === 'arrayObject') {
                        const numOfItems = data.reduce((acc, row) => {
                          //Extra check to make sure we have a value (Not undefined)
                          if (row[col.value] && (row[col.value].length > acc)) {
                            return row[col.value].length
                          }

                          return acc
                        }, 0)

                        return Array(numOfItems).fill('').map((c, colIdx) => {
                          //Extra check to make sure we have a value (Not undefined)
                          if (row && row[col.value] && row[col.value][colIdx]) {
                            return (
                              <TD key={`${row._id}-col-${i}-${colIdx}`} data-label={_label} className="sp-tickets-td">
                                <Comp row={row} name={col.value + '.' + colIdx + '.' + col.key} extra={extra} keyValue={_field} />
                              </TD>
                            )
                          }

                          return <TD key={`${row._id}-col-${i}-${colIdx}`} data-label={_label} className="sp-tickets-td" />
                        })
                      }

                      //If we have no value on createdByName we set it to anonmyous
                      const dataRow = { ...row };
                      dataRow.createdByName = dataRow.createdByName ? dataRow.createdByName : 'Anonymous';
                      return (
                        <TD key={`${row._id}-col-${i}`} data-label={_label} className="sp-tickets-td">
                          <Comp row={dataRow} name={col.key ? col.value + '.' + col.key : col.value} extra={extra} keyValue={_field} />
                        </TD>
                      );
                    } else {
                      return null;
                    }
                  })}
                </TR>
              );
            })}
          </TBody>
        </Table>
        {filter && data.length === 0 && (
          <NoDataWrapper>{intl.formatMessage({ id: 'Tickets.NoResult' })}</NoDataWrapper>
        )}

        {hasPagination && (
          <PaginationBar
            pageSize={pageSize}
            page={page}
            setPage={setPage}
            totalCount={totalCount}
          />
        )}
      </Wrapper>
    </React.Fragment>
  );
};

export default injectIntl(Tickets);
